import { companiesCompanyIdEmailSelfServeConfigurationData } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

import type { AllRouteEndpoints } from "../routeTypes";

// Refetched so the page picks up the run the endpoint just seeded: configuration_data carries its
// per-pool status while CreateSesIpPoolJob works through the pools.
export const postCompaniesCompanyIdEmailSelfServeIpPoolsCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdEmailSelfServeConfigurationData,
];
